import http from "@/libs/http";
import { MessageBox } from "element-ui";
import router from "@/router";
export default {
  initCurrentUserInfo: function({ commit }) {
    return http.userCurrent().then(response => {
      var res = http.data(response);
      if (http.success(res)) {
        commit("setUserInfo", res.data);
        commit("calculateRole", res.data);
      } else {
        MessageBox.confirm("由于无法获取您的个人信息将会退出系统，是否继续？", res.msg, {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "error"
        }).then(() => {
          router.push("/login");
        });
      }
    });
  },
  /**获取字典信息 */
  getDicts: ({ commit }) => {
    return http.getDictTypes().then(response => {
      let _res = http.data(response);
      let _datas = [];
      for (let i in _res.data) {
        _datas.push({ dictType: _res.data[i].code });
      }
      http.getDictList(_datas).then(response => {
        let res = http.data(response);
        if (res.status === "SUCCESS") {
          commit("setDicts", res.data);
        }
      });
    });
  }
};
